import { Phone } from "lucide-react";
import { CONTACT } from "@/data/site";

export const FloatingCall = () => {
  return (
    <a
      data-testid="floating-call-button"
      href={`tel:${CONTACT.phoneTel}`}
      aria-label="Call CWood Construction now"
      className="lg:hidden fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#1656b8] text-white rounded-full pl-4 pr-5 py-4 font-semibold shadow-2xl animate-pulse-ring"
    >
      <Phone size={20} />
      Call Now
    </a>
  );
};
